/* @flow */
import * as React from 'react';

import { AdminAddAdminModal } from 'admin/components/AdminAddAdmin';
import AdminRemoveAdminDialog from 'admin/components/AdminRemoveAdminDialog';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import AddButton from 'components/AddButton';
import ModalTrigger from 'components/ModalTrigger';
import Table from 'components/Table';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';

export type OrganizationInfo = {
  name: string,
  id: Backbone$Id,
};

type Props = {
  admins: *,
  districtId?: number,
  organizations: Array<OrganizationInfo>,
  organizationType: string,
};

function AdminAdminsView({ admins, districtId, organizations, organizationType }: Props) {
  return (
    <section className="AdminAdminsView">
      <TitleHeader
        title={`${organizationType} administrators`}
        subtext={`${organizationType} administrators have the ability to manage users, send messages, and view stats.`}
        textAlign="left"
      />
      <Table
        actionsColumn
        actionsColumnShowOnHover
        actionsRow={
          <ModalTrigger
            modal={
              <AdminAddAdminModal
                organizationType={organizationType.toLowerCase()}
                districtId={districtId}
                organizations={organizations}
                onRequestHide={() => undefined}
              />
            }>
            <AddButton>
              <Text wrap={false}>Add a {organizationType.toLowerCase()} administrator</Text>
            </AddButton>
          </ModalTrigger>
        }
        head={
          <tr>
            <th>Name</th>
            {!!districtId && <th>School</th>}
            <th />
          </tr>
        }>
        <tbody>
          {admins.map(admin => {
            const { uuid, name, firstName, lastName } = admin;
            const fullName = firstName && lastName ? `${firstName} ${lastName}` : name;

            return (
              <tr key={`${uuid}.${admin.organizationId}`}>
                <td>{fullName}</td>
                {!!districtId && <td>{admin.organizationName}</td>}
                <td>
                  <Buttons>
                    <ModalTrigger
                      modal={
                        <AdminRemoveAdminDialog
                          firstName={firstName}
                          name={fullName}
                          organizationId={admin.organizationId}
                          organizationType={organizationType.toLowerCase()}
                          uuid={uuid}
                          districtId={districtId}
                        />
                      }>
                      <Button color="apple" level="secondary" size="xsmall">
                        Remove as admin
                      </Button>
                    </ModalTrigger>
                  </Buttons>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </section>
  );
}

export default AdminAdminsView;
